export default "__VITE_ASSET__C2YmV3zy__"